import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import GulfWarServiceDescription from '../../../../components/FormDescriptions/GulfWarServiceDescription';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['service-info--gulf-war-service-title'];
const INPUT_LABEL = content['service-info--gulf-war-service-label'];
const ARIA_DESC_TEXT = content['service-info--gulf-war-service-aria-label'];

const { gulfWarService } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    gulfWarService: yesNoUI({
      title: INPUT_LABEL,
      description: GulfWarServiceDescription,
      headerAriaDescribedby: ARIA_DESC_TEXT,
    }),
  },
  schema: {
    type: 'object',
    properties: { gulfWarService },
  },
};
